import React, { Fragment, useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { NewContextModal } from './modals/NewContextModal'
import { DevKeyModal } from './modals/DevKeyModal'
import { ResetNameDomainModal } from './modals/ResetNameDomainModal'
import { OrganizationDetails } from './OrganizationDetails'
import { useStateValue } from '@State'

export const OrganizationContainer = props => {
  const [currentState, dispatch] = useStateValue()
  const [newContextModalOpen, toggleContextModal] = useState(false)
  const [devKeyModalOpen, toggleDevKeyModal] = useState(false)
  const [resetModalOpen, toggleResetModal] = useState(false)

  useEffect(() => {
    if (currentState.selectedOrg) {
      if (props.match.params.orgId !== currentState.selectedOrg.id) {
        dispatch({
          type: 'selectOrg',
          payload: null,
        })
      }
    }
  }, [])

  return (
    <Fragment>
      <div className="card-myed">
        <div className="pull-right">
          <div
            className="btn btn-myed btn-default btn-default-myed btn-sm-myed mr-4"
            onClick={() => toggleResetModal(!resetModalOpen)}
          >
            <div className="fa-regular fa-undo fa-fw mr-2" /> Reset Name and Domain
          </div>
          <div
            className="btn btn-warning btn-myed btn-warning-myed btn-sm-myed"
            onClick={() => toggleDevKeyModal(!devKeyModalOpen)}
          >
            <div className="fa-regular fa-key fa-fw mr-2" /> Dev Key
          </div>
          <div
            className="btn btn-myed btn-primary btn-primary-myed btn-sm-myed"
            onClick={() => toggleContextModal(!newContextModalOpen)}
          >
            <div className="fa-regular fa-plus fa-fw mr-2" /> Add New Context
          </div>
        </div>
        <h3>Organization Details</h3>
        <OrganizationDetails orgId={props.match.params.orgId} />
      </div>
      <NewContextModal
        orgId={props.match.params.orgId}
        show={newContextModalOpen}
        toggle={toggleContextModal}
      />
      <DevKeyModal
        orgId={props.match.params.orgId}
        show={devKeyModalOpen}
        toggle={toggleDevKeyModal}
      />
      <ResetNameDomainModal
        orgId={props.match.params.orgId}
        show={resetModalOpen}
        toggle={toggleResetModal}
      />
    </Fragment>
  )
}

OrganizationContainer.propTypes = {
  match: PropTypes.object,
}
